import { makeStyles } from '@material-ui/core';

import { TableColumn } from '../../../../../../../../config/types';
import { useScreen } from '../../../../../../../../hooks/useScreen';

export const usePaymentPlanTable = () => {
  const { isMobile } = useScreen();

  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
  });

  const classes = useStyles();

  const columnsDesktop: TableColumn[] = [
    { name: 'quotaNumber', label: '#', align: 'center', sticky: true, colWidth: '40px' },
    { name: 'dueDate', label: 'DUE_DATE', align: 'left' },
    { name: 'sentDate', label: 'SENT_DATE', align: 'left' },
    { name: 'paymentDate', label: 'PAYMENT_DATE', align: 'left' },
    { name: 'quota', label: 'AMOUNT', align: 'left' },
    { name: 'status', label: 'STATUS', align: 'left', colWidth: '80px' },
    { name: 'more_actions', label: '', align: 'right', colWidth: '24px' },
  ];

  const columnsMobile: TableColumn[] = [
    { name: 'quotaNumber', label: '#', align: 'center', sticky: true, colWidth: '40px' },
    { name: 'dueDate', label: 'DUE_DATE', align: 'left' },
    { name: 'sentDate', label: 'SENT_DATE', align: 'left' },
    { name: 'paymentDate', label: 'PAYMENT_DATE', align: 'left' },
    { name: 'quota', label: 'AMOUNT', align: 'left' },
    { name: 'status', label: 'STATUS', align: 'left', colWidth: '80px' },
    { name: 'more_actions', label: '', align: 'right', colWidth: '24px' },
  ];

  const columns = isMobile ? columnsMobile : columnsDesktop;

  return { classes, columns };
};
